function cp10Message(root, key, fallback) {
  try {
    const text = JSON.parse(root.querySelector('[data-cp10-messages]')?.textContent || '{}')[key] || fallback;
    const decoder = document.createElement('textarea');
    decoder.innerHTML = text;
    return decoder.value;
  }
  catch { return fallback; }
}
(() => {
  document.querySelectorAll('[data-creator-refined]').forEach(root => {
    const header = document.querySelector('.ds-header');
    const main = root.closest('main');
    if (main && !main.hasAttribute('tabindex')) main.setAttribute('tabindex', '-1');
    // The Creator link stays on this page, retaining campaign and locale parameters.
    document.querySelectorAll('.ds-header a[href], .ds-footer a[href]').forEach(link => {
      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin || url.pathname !== location.pathname) return;
      if (url.searchParams.get('view') !== 'store-creator' && !url.pathname.endsWith('/pages/creator-program')) return;
      link.setAttribute('aria-current', 'page');
      link.setAttribute('href', '#main');
    });
    const updateOffset = () => {
      const height = header ? header.getBoundingClientRect().height : 0;
      root.style.setProperty('--cp5-anchor-offset', `${height + 24}px`);
    };
    updateOffset();
    if (header && 'ResizeObserver' in window) new ResizeObserver(updateOffset).observe(header);
    const sample = root.querySelector('#cp6-sample-application');
    if (sample) {
      root.setAttribute('data-cp6-ready', '');
      const applicationLinks = root.querySelectorAll('[data-cp6-apply]');
      const sync = () => applicationLinks.forEach(link => link.setAttribute('aria-expanded', String(sample.open)));
      const nativeForms = sample.querySelector('[data-cp9-native-forms]');
      let focusNativeField = false;
      let readinessTimer;
      const styledRoots = new WeakSet();
      const watchedForms = new WeakSet();
      let submissionTimer;
      // Shopify Forms can leave its loading state set when invisible hCaptcha
      // rejects. Recover through a fresh verification page, never by bypassing
      // verification, enabling its disabled button, or auto-submitting twice.
      const recoveryKey = 'sothing-creator-form-retry-v1';
      let submitting = false;
      const showRecovery = message => {
        let status = nativeForms.querySelector('[data-cp9-submit-status]');
        if (!status) {
          status = document.createElement('p');
          status.className = 'cp5-note';
          status.setAttribute('data-cp9-submit-status', '');
          status.tabIndex = -1;
          nativeForms.appendChild(status);
        }
        clearTimeout(submissionTimer);
        const failedSubmit = nativeForms.querySelector('shopify-forms-embed')?.shadowRoot?.querySelector('button[type="submit"]');
        if (failedSubmit) {
          failedSubmit.hidden = true;
          failedSubmit.style.setProperty('display', 'none', 'important');
        }
        status.replaceChildren();
        status.setAttribute('role', 'alert');
        const explanation = document.createElement('span');
        explanation.textContent = message;
        const retry = document.createElement('button');
        retry.type = 'button';
        retry.className = 'cp5-button cp5-button-outline';
        retry.style.margin = '12px 0 0';
        retry.textContent = cp10Message(root, 'retry', "Reload verification & retry");
        retry.addEventListener('click', () => {
          const shadow = nativeForms.querySelector('shopify-forms-embed')?.shadowRoot;
          const draft = {savedAt: Date.now(), fields: {}, choices: {}};
          ['first_name', 'email', 'custom#profile_link_or_handle', 'custom#note_optional'].forEach(id => {
            const field = shadow?.getElementById(id);
            if (field) draft.fields[id] = field.value;
          });
          ['country_region', 'main_platform', 'content_type_optional'].forEach(key => {
            const button = shadow?.querySelector(`button[aria-labelledby*="custom#${key}-selector-label"]`);
            if (button) draft.choices[key] = button.textContent.trim();
          });
          try { sessionStorage.setItem(recoveryKey, JSON.stringify(draft)); } catch { /* Retry still works if tab storage is unavailable. */ }
          retry.disabled = true;
          location.reload();
        });
        status.append(explanation, document.createElement('br'), retry);
        status.hidden = false;
        status.focus({preventScroll: true});
      };
      window.addEventListener('unhandledrejection', event => {
        if (!submitting) return;
        const reason = String(event.reason?.message || event.reason || '');
        if (/^(challenge-error|script-error|network-error|internal-error|captcha-error)$/.test(reason)) {
          showRecovery(cp10Message(root, 'unconfirmed', "Your application has not been confirmed. Reload verification to retry; your details will stay in this tab."));
        }
      });
      const restoreDraft = shadow => {
        let draft;
        try {
          draft = JSON.parse(sessionStorage.getItem(recoveryKey) || 'null');
          sessionStorage.removeItem(recoveryKey);
        } catch { return; }
        if (!draft || Date.now() - draft.savedAt > 600000 || !draft.fields) return;
        Object.entries(draft.fields).forEach(([id, value]) => {
          const field = shadow.getElementById(id);
          if (!field || field.value || typeof value !== 'string' || value.length > 2000) return;
          const proto = field.tagName === 'TEXTAREA' ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
          Object.getOwnPropertyDescriptor(proto, 'value').set.call(field, value);
          field.dispatchEvent(new Event('input', {bubbles: true}));
          field.dispatchEvent(new Event('change', {bubbles: true}));
        });
        // Restore only visible, exact existing choices via normal UI handlers.
        const choices = Object.entries(draft.choices || {});
        const afterRender = callback => requestAnimationFrame(() => requestAnimationFrame(callback));
        const choose = index => {
          if (index >= choices.length) return;
          const [key, label] = choices[index];
          const button = shadow.querySelector(`button[aria-labelledby*="custom#${key}-selector-label"]`);
          if (!button || !label || /^Select /i.test(label)) return choose(index + 1);
          button.click();
          afterRender(() => {
            const option = shadow.getElementById('select-custom#'+key+'-'+label) || Array.from(shadow.querySelectorAll('[role="option"]')).find(node => node.textContent.trim() === label);
            if (option) option.click();
            else button.click();
            afterRender(() => choose(index + 1));
          });
        };
        afterRender(() => choose(0));
      };

      const styleNativeForm = shadow => {
        if (!shadow || styledRoots.has(shadow) || !nativeForms.dataset.cp9Styles) return;
        styledRoots.add(shadow);
        const applyPresentation = () => {
          const status = nativeForms.querySelector('[data-cp9-submit-status]');
          const nativeForm = shadow.querySelector('form');
          if (!nativeForm) {
            clearTimeout(submissionTimer);
            submitting = false;
            if (status) status.hidden = true;
          } else if (!watchedForms.has(nativeForm)) {
            watchedForms.add(nativeForm);
            restoreDraft(shadow);
            nativeForm.addEventListener('submit', () => {
              submitting = true;
              clearTimeout(submissionTimer);
              if (status) status.hidden = true;
              submissionTimer = setTimeout(() => {
                const submit = nativeForm.querySelector('[type="submit"]');
                if (nativeForm.isConnected && submit?.disabled) {
                  showRecovery(cp10Message(root, 'unconfirmed', "Your application has not been confirmed. Reload verification to retry; your details will stay in this tab."));
                }
              }, 25000);
            }, true);
          }
          if (!shadow.querySelector('[data-cp9-presentation]')) {
            const stylesheet = document.createElement('link');
            stylesheet.rel = 'stylesheet';
            stylesheet.href = nativeForms.dataset.cp9Styles;
            stylesheet.setAttribute('data-cp9-presentation', '');
            shadow.appendChild(stylesheet);
          }
          // Presentation only: never change field names, values, required rules or recipients.
          const translatedLabels = {'Name': root.dataset.cpName, 'Email': root.dataset.cpEmail, 'Country / Region': root.dataset.cpCountry, 'Country / region': root.dataset.cpCountry, 'Main Platform': root.dataset.cpPlatform, 'Main platform': root.dataset.cpPlatform, 'Profile Link or @Handle': root.dataset.cpProfile, 'Profile link or @handle': root.dataset.cpProfile, 'Note (optional)': root.dataset.cpNote, 'Note (Optional)': root.dataset.cpNote, 'Submit Application': root.dataset.cpSend, 'Send sample application': root.dataset.cpSend, 'Select country / region': root.dataset.cpSelectCountry, 'Select platform': root.dataset.cpSelectPlatform};
          Object.assign(translatedLabels, {'Your details': root.dataset.cpTitle, 'No account needed.': root.dataset.cpNoAccount, 'Content type (optional)': root.dataset.cpContent, 'Used to review your application and reply.': root.dataset.cpUse});
          shadow.querySelectorAll('[aria-label="Your details"]').forEach(element => {
            if (root.dataset.cpTitle) element.setAttribute('aria-label', root.dataset.cpTitle);
          });
          shadow.querySelectorAll('label,button,legend,h2,p').forEach(element => {
            const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
            let node;
            while ((node = walker.nextNode())) {
              const source = node.textContent.trim();
              const translated = translatedLabels[source];
              if (translated && translated !== source) node.textContent = node.textContent.replace(source, translated);
            }
          });
          const hints = [
            ['first_name', 'e.g. Alex Taylor', 'name'],
            ['email', 'e.g. alex@example.com', 'email'],
            ['custom#profile_link_or_handle', root.dataset.cpProfileHint || 'e.g. @yourname or a public profile link', 'off']
          ];
          hints.forEach(([id, placeholder, autocomplete]) => {
            const input = shadow.getElementById(id);
            if (!input) return;
            input.placeholder = placeholder;
            input.autocomplete = autocomplete;
            input.setAttribute('aria-required', 'true');
          });
          const note = shadow.querySelector('textarea[name="custom#note_optional"]');
          if (note) {
            note.placeholder = root.dataset.cpNoteHint || 'Anything else you would like us to know';
            if (!note.id) note.id = note.name;
            note.setAttribute('aria-label', root.dataset.cpNote || 'Note (optional)');
          }
          ['country_region', 'main_platform'].forEach(key => {
            shadow.querySelector(`button[aria-labelledby*="custom#${key}-selector-label"]`)?.setAttribute('aria-required', 'true');
          });
          [['country_region',root.dataset.cpSelectCountry],['main_platform',root.dataset.cpSelectPlatform],['content_type_optional',root.dataset.cpContent]].forEach(([key,hint]) => {
            const value = shadow.getElementById(`custom#${key}-selector-value`);
            if (value && hint) value.dataset.placeholder = hint;
          });
        };
        applyPresentation();
        new MutationObserver(applyPresentation).observe(shadow, {childList: true, subtree: true});
      };
      const checkNativeForms = (attempt = 0) => {
        clearTimeout(readinessTimer);
        if (!nativeForms || !sample.open) return;
        const shadow = nativeForms.querySelector('shopify-forms-embed')?.shadowRoot;
        const field = shadow?.querySelector('input:not([type="hidden"]),textarea');
        const loading = nativeForms.querySelector('[data-cp9-form-loading]');
        if (field) {
          styleNativeForm(shadow);
          if (loading) loading.hidden = true;
          if (focusNativeField) field.focus({preventScroll: true});
          focusNativeField = false;
          return;
        }
        if (attempt < 100) readinessTimer = setTimeout(() => checkNativeForms(attempt + 1), 200);
        else if (loading) loading.textContent = root.dataset.cpSlow || 'The form is taking longer to load. You can email us below.';
      };
      const openApplication = (focus = false) => {
        sample.open = true;
        sync();
        updateOffset();
        const field = sample.querySelector('input:not([type="hidden"])');
        if (focus && field) field.focus({preventScroll: true});
        if (nativeForms) {
          focusNativeField = focusNativeField || focus;
          checkNativeForms();
        }
        const top = window.scrollY + sample.getBoundingClientRect().top - (header ? header.getBoundingClientRect().height : 0) - 24;
        window.scrollTo({top, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      sample.addEventListener('toggle', () => {
        sync();
        if (sample.open && nativeForms) checkNativeForms();
        if (!sample.open && applicationLinks[0]) applicationLinks[0].focus();
      });
      applicationLinks.forEach(link => link.addEventListener('click', event => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        if (location.hash !== link.hash) history.pushState(history.state, '', link.hash);
        openApplication(true);
      }));
      window.addEventListener('hashchange', () => {
        if (location.hash === '#cp6-sample-application') openApplication();
      });
      if (location.hash === '#cp6-sample-application') openApplication();
      const result = sample.querySelector('[data-cp6-result]');
      if (result) {
        sample.open = true;
        result.focus({preventScroll: true});
        result.scrollIntoView({block: 'center'});
      }
      const platform = sample.querySelector('#cp7-platform');
      const profile = sample.querySelector('#cp6-profile');
      const profileUrl = sample.querySelector('#cp7-profile-url');
      const content = sample.querySelector('#cp7-content');
      const note = sample.querySelector('#cp7-note');
      const form = sample.closest('form');
      if (platform && profile) {
        const platformForHost = host => {
          host = host.toLowerCase().replace(/^www\./, '');
          if (host === 'instagram.com' || host.endsWith('.instagram.com')) return 'Instagram';
          if (host === 'tiktok.com' || host.endsWith('.tiktok.com')) return 'TikTok';
          if (host === 'youtube.com' || host.endsWith('.youtube.com') || host === 'youtu.be') return 'YouTube';
          return 'Other';
        };
        const readProfile = () => {
          const value = profile.value.trim();
          if (!value) return {valid: true, url: ''};
          const isLink = /^https?:\/\//i.test(value) || /^www\./i.test(value) || (value.includes('.') && value.includes('/')) || platform.value === 'Other';
          if (isLink) {
            try {
              const url = new URL(/^https?:\/\//i.test(value) ? value : 'https://' + value);
              if (!['https:', 'http:'].includes(url.protocol) || !url.hostname.includes('.') || url.username || url.password) return {valid: false};
              return {valid: true, url: url.href, platform: platformForHost(url.hostname)};
            } catch { return {valid: false}; }
          }
          const handle = value.replace(/^@/, '');
          if (!['Instagram', 'TikTok', 'YouTube'].includes(platform.value) || !/^[\p{L}\p{N}_.-]+$/u.test(handle)) return {valid: false};
          const prefix = {Instagram: 'https://www.instagram.com/', TikTok: 'https://www.tiktok.com/@', YouTube: 'https://www.youtube.com/@'}[platform.value];
          return {valid: true, url: prefix + handle};
        };
        const guideProfile = (detectPlatform = false) => {
          const result = readProfile();
          if (result.platform && profile.value.trim() && (detectPlatform || !platform.value)) platform.value = result.platform;
          const mismatch = result.platform && platform.value && platform.value !== 'Other' && platform.value !== result.platform;
          profile.placeholder = profile.getAttribute('data-placeholder-' + platform.value.toLowerCase()) || profile.dataset.placeholderDefault;
          profile.setCustomValidity(!result.valid ? profile.dataset.profileError : mismatch ? profile.dataset.profileMismatch : '');
          if (profileUrl) profileUrl.value = result.valid && !mismatch ? result.url || '' : '';
        };
        platform.addEventListener('change', () => guideProfile());
        profile.addEventListener('input', () => guideProfile(true));
        profile.addEventListener('change', () => guideProfile(true));
        profile.addEventListener('blur', () => guideProfile());
        if (form) form.addEventListener('submit', () => guideProfile());
        guideProfile();
      }
      if (content && note) content.addEventListener('change', () => {
        if (content.value === 'Other') note.open = true;
      });
      sync();
    }
    root.querySelectorAll('[data-cp5-jump]').forEach(link => {
      link.addEventListener('click', event => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const target = document.getElementById(link.hash.slice(1));
        if (!target) return;
        event.preventDefault();
        updateOffset();
        // Hash-only updates preserve attribution, preview and other query parameters.
        if (location.hash !== link.hash) history.pushState(history.state, '', link.hash);
        target.focus({preventScroll: true});
        target.scrollIntoView({block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      });
    });
  });
})();


/* Creator application UX v10 — observe native Forms success, never fabricate it. */
(() => {
  const root = document.querySelector('[data-creator-refined]');
  const host = root?.querySelector('[data-cp9-native-forms]');
  if (!host) return;
  const styled = new WeakSet(), bound = new WeakSet();
  let shown = false, lastEmail = '';
  const style = document.createElement('style');
  style.textContent = `.cp-confirmation{border:0;border-radius:20px;padding:38px 32px;width:min(440px,calc(100vw - 32px));color:#222722;background:#fff;box-sizing:border-box;text-align:center;box-shadow:0 24px 80px #18251a30}.cp-confirmation::backdrop{background:#151b1666;backdrop-filter:blur(3px)}.cp-confirmation .cp-done-icon{display:grid;place-items:center;width:56px;height:56px;margin:0 auto 22px;background:#edf4e9;color:#4b6541;border-radius:50%;font-size:26px}.cp-confirmation h2{margin:0 0 14px;font-size:28px;line-height:1.15;letter-spacing:-.8px;color:#222722}.cp-confirmation p{margin:0;font-size:14px;line-height:1.65;color:#687168}.cp-confirmation strong{display:block;color:#434c41;overflow-wrap:anywhere;font-weight:500;margin:8px 0}.cp-confirmation small{display:block;color:#838c80;line-height:1.6;font-size:12px;margin:18px 0 26px}.cp-confirmation button{width:100%;min-height:44px;border:0;border-radius:9px;background:#222722;color:white;font:inherit;font-size:14px;cursor:pointer}.cp-confirmation button:focus-visible{outline:3px solid #91a486;outline-offset:3px}[data-cp10-complete] .cp9-form-guide{display:none}[data-cp10-complete] .cp6-application-body{display:block;max-width:620px;margin:auto}`;
  document.head.appendChild(style);
  const showSuccess = () => {
    if (shown) return;
    shown = true; root.setAttribute('data-cp10-complete','');
    const previous = document.activeElement;
    const dialog = document.createElement('dialog'); dialog.className='cp-confirmation'; dialog.setAttribute('aria-labelledby','cp-confirmation-title'); dialog.setAttribute('aria-describedby','cp-confirmation-description');
    const icon = document.createElement('span'); icon.className='cp-done-icon';icon.setAttribute('aria-hidden','true');icon.textContent='✓';
    const title = document.createElement('h2');title.id='cp-confirmation-title';title.textContent=cp10Message(root, 'received', "Application received.");
    const description=document.createElement('p');description.id='cp-confirmation-description';description.textContent=cp10Message(root, 'thanks', "Thanks for your interest in SOTHING. We’ll review your profile and email you if it’s a match.");
    const email=document.createElement('strong');email.textContent=lastEmail;
    const note=document.createElement('small');note.textContent=cp10Message(root, 'inbox', "Check your inbox and spam folder. No need to apply again. Applying does not guarantee a sample.");
    const done=document.createElement('button');done.type='button';done.textContent=cp10Message(root, 'done', "Got it");done.addEventListener('click',()=>dialog.close());
    dialog.addEventListener('close',()=>{dialog.remove();if(previous?.isConnected)previous.focus({preventScroll:true});});
    dialog.append(icon,title,description,email,note,done);document.body.appendChild(dialog);dialog.showModal();done.focus({preventScroll:true});
  };
  const writeValue = (input, value) => {
    if (!input || input.value===value) return;
    Object.getOwnPropertyDescriptor(HTMLInputElement.prototype,'value').set.call(input,value);
    input.dispatchEvent(new Event('input',{bubbles:true}));input.dispatchEvent(new Event('change',{bubbles:true}));
  };
  const parsedProfile = value => {
    value=value.trim();
    if (!value) return {error:cp10Message(root, 'profile', "Enter your profile link or @handle.")};
    if (/^(https?:\/\/|(?:www\.|m\.)?(?:instagram|tiktok|youtube)\.com\/)/i.test(value)) {
      try {
        const url=new URL(value.includes('://')?value:'https://'+value), host=url.hostname.toLowerCase().replace(/^(www\.|m\.)/,'');
        if(!['http:','https:'].includes(url.protocol)||url.username||url.password||url.port) return {error:cp10Message(root, 'public_profile', "Enter a public profile link.")};
        const platform={'instagram.com':'Instagram','tiktok.com':'TikTok','youtube.com':'YouTube'}[host];
        const path=url.pathname.replace(/^\/+|\/+$/g,'');
        if(platform&&(!path||/^(p|reel|reels|stories|explore|watch|shorts|playlist|results|feed|video)(\/|$)/i.test(path)||(path.includes('/')&&!(platform==='YouTube'&&/^channel\/[A-Za-z0-9_-]+$/.test(path)))))return {error:cp10Message(root, 'post', "Use your profile or channel page, not a post or video.")};
        return {platform:platform||'Other',value:platform?`https://www.${host}/${path}`:value};
      } catch {return {error:cp10Message(root, 'check_profile', "Check your profile link and try again.")};}
    }
    if(!/^@?[\p{L}\p{N}_.-]{2,120}$/u.test(value))return {error:cp10Message(root, 'valid_profile', "Enter a valid profile link or @handle.")};
    return {value};
  };
  const attach = shadow => {
    if(!shadow||styled.has(shadow))return;
    styled.add(shadow);
    const css=document.createElement('style');css.textContent='[data-cp10-error]{padding:10px 12px;margin:10px 0;color:#9d3d32;background:#fff4f1;border-radius:7px;font-size:13px;line-height:1.5}[data-cp10-error][hidden]{display:none!important}input[aria-invalid="true"]{outline-color:#ae493c!important;border-color:#ae493c!important}';shadow.appendChild(css);
    const choice = key => shadow.querySelector(`button[aria-labelledby*="custom#${key}-selector-label"]`);
    const emptyChoice = (button, key) => {
      const value = button?.textContent.trim();
      const placeholder = key === 'country_region' ? root.dataset.cpSelectCountry : root.dataset.cpSelectPlatform;
      return !value || /^Select /i.test(value) || value === placeholder;
    };
    const check = () => {
      const form=shadow.querySelector('form');
      const headings=Array.from(shadow.querySelectorAll('h1,h2,h3,[role="heading"]'));
      if(!form && headings.some(h=>/^Application received[.!]?$/i.test(h.textContent.trim()))) showSuccess();
      if(!form||bound.has(form))return;
      bound.add(form);
      const name=shadow.getElementById('first_name'),email=shadow.getElementById('email'),profile=shadow.getElementById('custom#profile_link_or_handle');
      if(name){name.autocomplete='name';name.addEventListener('blur',()=>writeValue(name,name.value.trim()));}
      if(email){email.autocomplete='email';email.inputMode='email';email.spellcheck=false;email.addEventListener('blur',()=>writeValue(email,email.value.trim().toLowerCase()));}
      let changingPlatform=false;
      if(profile){profile.autocomplete='off';profile.spellcheck=false;profile.addEventListener('blur',()=>{
        const parsed=parsedProfile(profile.value);if(parsed.error)return;
        writeValue(profile,parsed.value);
        const button=choice('main_platform');
        if(!parsed.platform||!button||changingPlatform||!emptyChoice(button,'main_platform'))return;
        changingPlatform=true;button.click();
        requestAnimationFrame(()=>requestAnimationFrame(()=>{const option=shadow.getElementById('select-custom#main_platform-'+parsed.platform)||Array.from(shadow.querySelectorAll('[role="option"]')).find(o=>o.textContent.trim()===parsed.platform);if(option)option.click();else button.click();changingPlatform=false;}));
      });}
      form.addEventListener('input',()=>{const alert=form.querySelector('[data-cp10-error]');if(alert)alert.hidden=true;});
      const validate=event=>{
        const issues=[]; const parsed=parsedProfile(profile?.value||'');
        [name,email,profile].forEach(input=>input?.removeAttribute('aria-invalid'));
        if(!name?.value.trim())issues.push([name,cp10Message(root, 'name', "Enter your name.")]);
        if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((email?.value||'').trim()))issues.push([email,cp10Message(root, 'email', "Enter a valid email, such as alex@example.com.")]);
        if(parsed.error)issues.push([profile,parsed.error]);
        const countryButton=choice('country_region'),platformButton=choice('main_platform');
        if(emptyChoice(countryButton,'country_region'))issues.push([countryButton,cp10Message(root, 'country', "Select your country or region.")]);
        const platform=platformButton?.textContent.trim();
        if(emptyChoice(platformButton,'main_platform'))issues.push([platformButton,cp10Message(root, 'platform', "Select your main platform.")]);
        if(parsed.platform&&platform&&!emptyChoice(platformButton,'main_platform')&&platform!=='Other'&&platform!==parsed.platform)issues.push([profile,cp10Message(root, 'mismatch', 'Your link is for {platform}. Update the platform or profile link.').replace('{platform}', parsed.platform)]);
        let alert=form.querySelector('[data-cp10-error]');
        if(!alert){alert=document.createElement('p');alert.dataset.cp10Error='';alert.setAttribute('role','alert');form.prepend(alert);}
        if(issues.length){event.preventDefault();event.stopImmediatePropagation();alert.textContent=issues[0][1];alert.hidden=false;issues.forEach(([input])=>input?.setAttribute('aria-invalid','true'));issues[0][0]?.focus();return false;}
        alert.hidden=true;lastEmail=(email?.value||'').trim();return true;
      };
      form.addEventListener('click',event=>{if(event.target.closest?.('button[type="submit"]'))validate(event);},true);
      form.addEventListener('submit',validate,true);
    };
    check();new MutationObserver(check).observe(shadow,{childList:true,subtree:true});
  };
  const discover=()=>attach(host.querySelector('shopify-forms-embed')?.shadowRoot);
  discover();new MutationObserver(discover).observe(host,{childList:true,subtree:true});
  let attempts=0;const timer=setInterval(()=>{discover();if(styled.has(host.querySelector('shopify-forms-embed')?.shadowRoot)||++attempts>100)clearInterval(timer);},200);
})();
